import { graphql } from 'gatsby';

import { getKey, isValidArray } from '../../../helpers';

/**
 * @param {any} props
 * @param {string} locale
 */
export const columnsMapping = (props, locale) => {
  const items = getKey(props, 'columncards');
  return {
    title: getKey(props, `title_${locale}`),
    subtitle: getKey(props, `subtitle_${locale}`),
    items:
      isValidArray(items) &&
      items.map((item) => ({
        key: getKey(item, 'key'),
        backgroundImage: getKey(item, 'backgroundImage.childImageSharp.fluid'),
        title: getKey(item, `title_${locale}`),
        description: getKey(item, `description_${locale}`),
      })),
    backgroundColor: props?.backgroundColor,
    variant: props?.variant,
  };
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment Columns on StrapiWidgetrels {
    columns {
      key: id
      title_en
      title_es
      subtitle_en
      subtitle_es
      columncards {
        title_en
        title_es
        description_en
        description_es
        backgroundImage {
          childImageSharp {
            fluid(maxWidth: 800, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      backgroundColor
      variant
      widgetPosition
    }
  }
`;
